import { BaseContainerModel } from '../base-container.model';
import { bl_mrp_job_order_hdr_RowInterface, bl_mrp_pi_worklog_Rowinterface, bl_mrp_process_instance_hdr_RowClass, bl_mrp_process_template_hdr_RowInterface } from '../../dbschema';

export class MrpPMCOperatorInstanceContainerModel extends BaseContainerModel {
  bl_mrp_process_instance_hdr: bl_mrp_process_instance_hdr_RowClass = new bl_mrp_process_instance_hdr_RowClass();
  bl_mrp_pi_worklog: bl_mrp_pi_worklog_Rowinterface[] = [];
  bl_mrp_job_order_hdrs: bl_mrp_job_order_hdr_RowInterface[] = [];
  bl_mrp_process_template_hdrs: bl_mrp_process_template_hdr_RowInterface[] = [];
}
